import { render, staticRenderFns } from "./SeriesDetail.vue?vue&type=template&id=cdcfe6f0&scoped=true&"
import script from "./SeriesDetail.vue?vue&type=script&lang=js&"
export * from "./SeriesDetail.vue?vue&type=script&lang=js&"
import style0 from "./SeriesDetail.vue?vue&type=style&index=0&id=cdcfe6f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcfe6f0",
  null
  
)

export default component.exports